import React from 'react';
import PropTypes from 'prop-types';

import {Formik} from 'formik';

import {useNavigate} from 'react-router-dom';

import RecordSchema from './RecordSchema';

import FormComponent from './FormComponent';

import {DisplayFormikState,} from 'pac-platform-ui-components';

import {FormWithActionBar} from './FormWithActionBar';

const RecordForm = ({ record, handleSubmit }) => {
    const navigate = useNavigate();

    const onSubmit = (values) => {
        handleSubmit(values);
        navigate('/');
        return false;
    };

    const renderForm = (props) => {
        return (
            <FormWithActionBar
                handleSubmit={props.handleSubmit}
                handleCancel={() => navigate('/')}
            >
                <FormComponent {...props} />
                {false && <DisplayFormikState {...props} />}
            </FormWithActionBar>
        );
    };

    let initialValues = {
        language: 'en',
        show_return_to: true,
        max_return_to: 2,
        password_and_sso: false,
    };

    if (typeof record !== 'undefined') {
        initialValues = record;
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {renderForm}
        </Formik>
    );
};

RecordForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
};

export default RecordForm;
